import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background p-4 sm:p-6 md:p-8">
      <div className="mx-auto w-full max-w-4xl bg-white rounded-xl shadow-card p-5 sm:p-7 md:p-10">
        <div className="flex items-center justify-between gap-3 mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-text">Privacy Policy</h1>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="text-primary underline underline-offset-4 hover:text-hover"
          >
            Back to Home
          </button>
        </div>

        <p className="text-secondary-text mb-6">
          Effective date: March 14, 2026
        </p>

        <div className="space-y-6 text-secondary-text leading-relaxed">
          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">1. Overview</h2>
            <p>
              PutPens is a task and project management platform for organizations. This Privacy Policy
              explains what information we collect, how we use it, and the choices available to users.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">2. Information We Collect</h2>
            <p>
              We may collect account information (such as name, email, role, and company), operational data
              (projects, tasks, comments, status updates, attachments), and technical data (device type,
              app version, and log data required to maintain service quality).
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">3. How We Use Information</h2>
            <p>
              Data is used to provide core app functionality, support authentication, send task and
              workflow notifications, maintain security, troubleshoot issues, and improve product
              reliability and user experience.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">4. Notifications</h2>
            <p>
              PutPens uses push notifications to inform users about relevant workflow events (for example,
              task assignments, status updates, and approval actions). Notification permissions can be
              controlled from device settings.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">5. Data Sharing</h2>
            <p>
              We do not sell personal data. Data may be shared with service providers only when required to
              operate the app (such as hosting, notifications, and infrastructure support) and under
              confidentiality and security obligations.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">6. Data Retention</h2>
            <p>
              We retain data for as long as needed to provide services to the organization and comply with
              legal obligations. Organizations may request deletion of their data subject to applicable
              law and contractual commitments.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">7. Security</h2>
            <p>
              We apply reasonable administrative and technical safeguards to protect data. No system is
              absolutely secure, but we continuously monitor and improve our security practices.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">8. Your Rights</h2>
            <p>
              Users may request access, correction, or deletion of personal data through their organization
              administrator or by contacting support, subject to applicable laws.
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">9. Contact</h2>
            <p>
              For privacy-related requests, contact: <span className="font-medium">support@putpens.com</span>
            </p>
          </section>

          <section>
            <h2 className="text-lg sm:text-xl font-semibold text-text mb-2">10. Policy Updates</h2>
            <p>
              We may update this Privacy Policy from time to time. The latest version is published on this
              page with the effective date shown above.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
